// extracted by mini-css-extract-plugin
export default {"Address":"index__Address__S2abe","createdAt":"index__createdAt__yL8Ro","Pagination":"index__Pagination__vMhlR"};